import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function GridReducer(state = initialState.selectedGridRow, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_GRID_ROW_SUCCESS:
      return action.selectedGridRow;
    default:
      return state;
  }
}
